export default function upscaleCanvas(originalCanvas, originalDpi, targetDpi) {
    const ratio = targetDpi / originalDpi;
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(originalCanvas.width * ratio);
    canvas.height = Math.round(originalCanvas.height * ratio);
    const ctx = canvas.getContext("2d");
    ctx.drawImage(originalCanvas, 0, 0, originalCanvas.width, originalCanvas.height, 0, 0, canvas.width, canvas.height);
    return canvas;
}
//# sourceMappingURL=upscaleCanvas.js.map